import React from 'react';

import {FormikTextArea} from './type/FormikTextArea';
import {RawTextArea} from './type/RawTextArea';
import {TextAreaWrapper} from './type/TextAreaStructure';

export function TextArea({raw, ...props}) {
    if (raw) {
        return <RawTextArea {...props} />;
    } else {
        return <FormikTextArea {...props} />;
    }
}

TextArea.Wrapper = TextAreaWrapper;
export {TextAreaWrapper};
